import notifee, { EventType } from "@notifee/react-native";

/** Matches expo-notifications default tap identifier. */
export const DEFAULT_ACTION_IDENTIFIER = "expo.modules.notifications.actions.DEFAULT";

/** @type {import('./notificationCheckIn.js').NotificationResponse | null} */
let lastResponse = null;

/** @type {Array<(response: import('./notificationCheckIn.js').NotificationResponse) => void>} */
const listeners = [];

/**
 * @param {{ type: number; detail: import('@notifee/react-native').EventDetail }} event
 * @returns {import('./notificationCheckIn.js').NotificationResponse | null}
 */
export function notifeeEventToResponse(event) {
  const notification = event?.detail?.notification;
  if (!notification) return null;

  const actionId = event.detail.pressAction?.id || DEFAULT_ACTION_IDENTIFIER;

  return {
    notification: {
      request: { identifier: notification.id || "unknown" },
      date: Date.now(),
    },
    actionIdentifier: actionId,
  };
}

/**
 * @param {{ type: number; detail: import('@notifee/react-native').EventDetail }} event
 */
export function handleNotifeeEvent(event) {
  if (event.type !== EventType.ACTION_PRESS && event.type !== EventType.PRESS) {
    return;
  }

  const response = notifeeEventToResponse(event);
  if (!response) return;

  lastResponse = response;
  listeners.forEach((callback) => callback(response));
}

/**
 * @returns {Promise<import('./notificationCheckIn.js').NotificationResponse | null>}
 */
export async function getLastNotificationResponseAsync() {
  if (lastResponse) return lastResponse;

  const initial = await notifee.getInitialNotification();
  if (!initial?.notification) return null;

  return {
    notification: {
      request: { identifier: initial.notification.id || "unknown" },
      date: Date.now(),
    },
    actionIdentifier: initial.pressAction?.id || DEFAULT_ACTION_IDENTIFIER,
  };
}

/**
 * @param {(response: import('./notificationCheckIn.js').NotificationResponse) => void} callback
 */
export function addNotificationResponseReceivedListener(callback) {
  listeners.push(callback);
  return {
    remove: () => {
      const index = listeners.indexOf(callback);
      if (index >= 0) listeners.splice(index, 1);
    },
  };
}
